import type { AutomaticProcessingStatusNotification } from '@/models/automaticProcessingStatus';
import { AutomaticProcessingStatus } from '@/models/automaticProcessingStatus';
import { defineStore } from 'pinia';
import { ref } from 'vue';

const useSignalRStore = defineStore('signalR', () => {
    const isLiveUpdatesAvailable = ref<boolean>(false);
    const isAutomaticProcessingPaused = ref<AutomaticProcessingStatus | undefined>(undefined);
    const setAutomaticProcessingStatus = (status: AutomaticProcessingStatus) => {
        isAutomaticProcessingPaused.value = status;
    };
    const updateAutomaticProcessingStatus = (
        notification: AutomaticProcessingStatusNotification
    ) => {
        setAutomaticProcessingStatus(notification.automatedStatus.status);
    };

    return {
        isLiveUpdatesAvailable,
        isAutomaticProcessingPaused,
        setAutomaticProcessingStatus,
        updateAutomaticProcessingStatus,
    };
});

export default useSignalRStore;
